import styled from "styled-components";
import Bg from "../../assets/bg-grid.svg";

export const LeaderBoardWrapper = styled.div`
  background-color: #72969b;
  background-position: center;
  background-size: 100vw;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

export const BackgroundGrid = styled.img`
  position: absolute;
  z-index: 1;
  width: 100vw;
  height: 100vh;
  object-fit: cover;
`;

export const DetailsWrapper = styled.div`
  background-color: rgba(62, 98, 106);
  width: 90%;
  height: 80%;
  margin-top: 60px;
  border-radius: 10px;
  padding: 10px;
  position: relative;
`;

export const TitleWrapper = styled.div`
  position: absolute;
  top: 13px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
`;

export const WoodImg = styled.img`
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const YellowLineExternal = styled.div`
  height: 100%;
  border: 1px solid #f3de8a;
`;

export const YellowLineInternal = styled.div`
  height: 98.4%;
  margin: 5px;
  border: 1px solid #f3de8a;

  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
`;

export const DataWrapper = styled.div`
  padding: 60px 0;
  height: 73%;
`;

export const TableWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: auto; /* ✅ Horizontal scroll if needed */
`;

export const Table = styled.div`
  display: table;
  width: 100%;
  height: 100%;
  border-spacing: 0 15px;
`;

export const TableHead = styled.div`
  display: table-header-group;
  background-color: transparent;
`;

export const TableRow = styled.div`
  display: table-row;
  border-radius: 5px;
`;

export const TableCell = styled.div`
  display: table-cell;
  padding: 16px 20px;
  vertical-align: middle;
  min-width: 120px;

  &:first-child {
    min-width: 80px;
  }
`;

export const NumberContainer = styled.div`
  background-color: #fe6030;
  border-radius: 50%;
  width: 26px;
  height: 26px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmblemImageWrapper = styled.div`
  height: 34px;
  width: 34px;
  margin: 0 auto;
  border-radius: 5px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmblemImage = styled.img`
  height: 26px;
`;
